import React from "react";
import {
  Footer,
  Navbar,
  AnniversaryDecoration,
  CookieConsent,
} from "../../components/Web";
import "./ClientLayoutTailwind.css";
import "./ClientLayout.scss";

export function ClientLayout(props) {
  const { children } = props;

  return (
    <div className="client-layout">
      <AnniversaryDecoration />
      <div className="client-layout__header">
        <Navbar />
      </div>
      {children}
      <div className="client-layout__footer">
        <Footer />
      </div>
      <CookieConsent />
    </div>
  );
}
